import React, { useState } from 'react';
import './index.css'
import MonthlyCost from './components/MonthlyCost';
import CostServices from './components/CostServices';
import CostPerRoom from './components/CostPerRoom';
import Navbar from './components/Navbar';
import EMQXMonthlyCost from './components/EMQXMonthlyCost';
import MongoDBMonthlyCost from './components/MongoDBMonthlyCost';

interface DashboardProps {
  token: string;
  logout:()=>void;
}

const Dashboard: React.FC<DashboardProps> = ({ token, logout }) => {
  const [isSideOpen, setSideOpen] = useState<boolean>(false);

  return (
    <div className="font-sans pb-3 flex items-start bg-[#f8f8f8] h-screen w-full mt-[150px]">
      <Navbar isOpen={isSideOpen} toggleSideBar={() => setSideOpen(!isSideOpen)} logout={logout}/>

      <div className={`main-content transition-all duration-300${isSideOpen ? 'shifted ml-[170px]' : 'collapsed ml-[70px]'}`}>
        <div className="flex justify-between items-center mb-5 relative">
          <h2 className="font-medium text-[18px] leading-[26px] tracking-[.15px] text-[#2d2d2d]">DevOps Dashboard</h2>
        </div>

        <div className="chart-wrapper flex flex-wrap gap-5">
          <div className="bar bg-white rounded shadow-md p-6 items-center">
            <MonthlyCost token={token} env="QA"/>
          </div>
          <div className="bar bg-white rounded shadow-md p-6 items-center">
            <MonthlyCost token={token} env="UAT"/>
          </div>
          <div className="bar bg-white rounded shadow-md p-6 items-center">
            <MonthlyCost token={token} env="PROD"/>
          </div>
          <div className="bar bg-white rounded shadow-md p-6 items-center">
            <EMQXMonthlyCost token={token}/>
          </div>
          <div className="bar bg-white rounded shadow-md p-6 items-center">
            <MongoDBMonthlyCost token={token}/>
          </div>
          <div className="pie bg-white rounded shadow-md p-2 items-center w-[330px] h-[350px]">
            <CostServices token={token} />
          </div> 
          <div className="line bg-white rounded shadow-md p-2 items-center">
            <CostPerRoom token={token}/>
          </div> 
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
